import { defineMessages } from 'react-intl';

export const contextPickerDialogMessages = defineMessages({
  addSession: {
    defaultMessage: 'Add a session',
    id: '0AYKpZB+Vp',
    description: 'Title of the composer session picker dialog',
  },
  addPatient: {
    defaultMessage: 'Add a patient',
    id: 'oyXn7HSy5/',
    description: 'Title of the composer patient picker dialog',
  },
  searchSessions: {
    defaultMessage: 'Search sessions',
    id: 'xRgtFiPT8w',
    description: 'Placeholder in the composer session picker dialog',
  },
  searchPatients: {
    defaultMessage: 'Search patients',
    id: 'FceK7LUM2o',
    description: 'Placeholder in the composer patient picker dialog',
  },
  clearSearch: {
    defaultMessage: 'Clear search',
    id: '0ef7S87pBP',
    description: 'Accessible label for the picker search clear button',
  },
  upcoming: {
    defaultMessage: 'Upcoming',
    id: 'l+fKIMaPH2',
    description: 'Session picker group heading for future calendar days',
  },
  today: {
    defaultMessage: 'Today',
    id: 'm8AkDivxc2',
    description: 'Session picker group heading for the current calendar day',
  },
  yesterday: {
    defaultMessage: 'Yesterday',
    id: 'r9aCu7XENl',
    description: 'Session picker group heading for the previous calendar day',
  },
  older: {
    defaultMessage: 'Older',
    id: '6af60eQiQ1',
    description: 'Session picker group heading for sessions older than yesterday',
  },
  noPatientsFound: {
    defaultMessage: 'No patients found',
    id: 'gXpSOTMqoB',
    description: 'Empty state when patient search returns no results',
  },
  noSessionsFound: {
    defaultMessage: 'No sessions found',
    id: 'PsWxNM5czE',
    description: 'Empty state when no recent sessions are available to link',
  },
  pickItemAria: {
    defaultMessage: '{name}, {secondary}',
    id: 'mxHeJDfVjD',
    description: 'Accessible label for a context picker row with a secondary line',
  },
});
